import { TagArticlesApi } from '../api/tagArticlesApi';
/**
 * Сервис для работы со статьями тега.
 * Инкапсулирует вызовы API и при необходимости может добавлять
 * кэширование, логику повтора и т.д.
 * Зеркалирует CategoryArticlesService.
 */
export class TagArticlesService {
    constructor() {
        this.api = new TagArticlesApi();
    }
    async getPage(tagId, params = {}) {
        return this.api.getArticles(tagId, params);
    }
}
